import { getRandomUid } from 'utilities/uuid.service';
import { useEffect, useState } from 'react';
import useDebounce from 'hooks/useDebounce';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import useChapters from 'hooks/API/GET/useChapters';

function ChapterSearch({ enableAPI, isMulti, values, handleChange, dependencies = {} }) {
  const { query = {}, classID = 'all', courseID = 'all' } = dependencies;
  const [chapters, setChapters] = useState([]);
  const [search, setSearch] = useState('');
  const [keyword, setKeyword] = useState('');

  const _id = getRandomUid();

  const { data, isLoading } = useChapters({
    enabled: enableAPI,
    classID,
    courseID,
    configs: { params: { mode: 'dropdown', keyword, ...query } },
  });

  useEffect(() => {
    if (data?.data) setChapters(data?.data || []);

    return () => {};
  }, [data?.data]);

  const __search = useDebounce(search, 1000);

  useEffect(() => {
    if (__search) setKeyword(__search);
  }, [__search]);

  return (
    <>
      <label htmlFor={_id}>Chapters</label>
      <AsyncTypeahead
        id={_id}
        filterBy={() => true}
        isLoading={isLoading}
        labelKey="name"
        // minLength={3}
        onSearch={(query) => setSearch(query)}
        options={chapters}
        placeholder="Search chapters..."
        selected={values}
        onChange={handleChange}
        renderMenuItemChildren={(option) => <>{option.name}</>}
        useCache={false}
      />
    </>
  );
}

ChapterSearch.defaultProps = {
  values: [],
  isMulti: false,
  handleChange: () => {},
};

export default ChapterSearch;
